import React, { useState, useCallback } from "react";
import "./With.css";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ContractDetails from "../../Contracts/ContractDetails";
import Change from "../../Common/StringToSub";
import { Container, Row, Col } from "react-bootstrap";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import { useDispatch, useSelector } from "react-redux";
import CopyComponent from "../../Component/CopyComponent/CopyComponent";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import moment from "moment";
import debounce from "lodash.debounce";
import { HiDownload } from "react-icons/hi";
import { Modal, Button } from "react-bootstrap";
import Popup from "reactjs-popup";
import { ethers } from "ethers";

import {
  approveWithdrawalRequest,
  fetchAllTransaction,
  rejectWithdrawalRequest,
} from "../../Actions/adminActions";
import GetChainId from "../../Common/GetChainId";
import getAddress from "../../Common/GetAddress";
import { parse } from "url";
import apiCall from "../../API/API";
import ExportButtons, { collectPages } from "../../Component/ExportButtons/ExportButtons";
import { toast } from "react-toastify";

const PendingWith = () => {
  const [data, setData] = useState([]);
  const { paymentRequests } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filter, setFilter] = useState("none");
  const [selectedToken, setSelectedToken] = useState();
  const [companyDetails, setCompanyDetails] = useState();
  const [show, setShow] = useState(false);
  const [search, setsearch] = useState({
    source: "withdrawal",
    status: "0",
    amount: "",
    username: "",
    search: "",
    startDate: "",
    endDate: "",
    uid: "",
  });
  const [limitFilter, setLimitFilter] = useState(20);
  const [dateFilter, setDateFilter] = useState("default");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [totalRecord, setTotalRecords] = useState(0);

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showRejectionReason, setShowRejectionReason] = useState(false);
  const [currentTxId, setCurrentTxId] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [showApproveAllModal, setShowApproveAllModal] = useState(false);
  const [currentApproveTxId, setCurrentApproveTxId] = useState(null);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [tx_hash, setTxHash] = useState("");
  const [tx_Ids, setTx_Ids] = useState([]);
  const [walletAddress, setWalletADdress] = useState([]);
  const [amount, setAmount] = useState([]);
  const [username, setUsername] = useState([]);
  const [token, setToken] = useState([]);
  const [tokenSymbol, setTokenSymbol] = useState([]);
  const [value, setValue] = useState();
  const fetchWithdraw = useCallback(
    debounce((params) => {
      dispatch(fetchAllTransaction(params));
    }, 500),
    [dispatch]
  );
  const { BigInt } = window;

  const toggleFilter = () => {
    if (filter === "none") {
      setFilter("flex");
    } else {
      setFilter("none");
    }
  };
  // function handleWithDap()
  // {

  // }

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else {
      setsearch((prev) => {
        const updatedSearch = { ...prev, [name]: value };
        Object.keys(updatedSearch).forEach((key) => {
          if (updatedSearch[key] === "" || updatedSearch[key] === 0) {
            delete updatedSearch[key];
          }
        });
        return updatedSearch;
      });
    }
    fetchWithdraw({
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
      ...(startDate && endDate ? { startDate, endDate } : {}),
    });
  };
  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };

  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let start = "";
    let end = "";
    switch (value) {
      case "today":
        start = today.startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = today.subtract(1, "days").startOf("day").format("YYYY-MM-DD");
        end = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = today.startOf("week").format("YYYY-MM-DD");
        end = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        start = "";
        end = "";
        break;
    }
    setStartDate(start);
    setEndDate(end);
  };

  const Addfilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };

    if (startDate) {
      queryParams.startDate = startDate;
    }
    if (endDate) {
      queryParams.endDate = endDate;
    }

    dispatch(fetchAllTransaction(queryParams));
  };

  const resetFilter = () => {
    setsearch({
      source: "withdrawal",
      status: "0",
      amount: "",
      username: "",
      search: "",
      startDate: "",
      endDate: "",
      uid: "",
    });
    setLimitFilter(20);
    setStartDate("");
    setEndDate("");
    setDateFilter("default");
    setCurrentPage(1);

    dispatch(
      fetchAllTransaction({
        page: 1,
        limit: 20,
        source: "withdrawal",
        status: "0",
      })
    );
  };

  useEffect(() => {
    const queryParams = {
      page: currentPage,
      limit: 20,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    if (startDate && endDate) {
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }
    fetchWithdraw(queryParams);
  }, [dispatch, currentPage, limitFilter, search, startDate, endDate]);

  useEffect(() => {
    setTotalPages(paymentRequests?.totalPages);
    setTotalRecords(paymentRequests?.totalRecords ?? 0);
  }, [paymentRequests]);

  const statusLabel = (status) =>
    status == 0 ? "Pending" : status == 1 ? "Approved" : "Rejected";

  const exportColumns = [
    { header: "Name", value: (row) => row?.name },
    { header: "Username", value: (row) => row?.username },
    { header: "Uid", value: (row) => row?.uid },
    { header: "Requested Amount", value: (row) => row?.amount },
    { header: "Admin Fee", value: (row) => row?.TDS },
    { header: "Transaction Charge", value: (row) => row?.tx_charge },
    { header: "Withdrawal Amount", value: (row) => row?.withdrawal_amount },
    { header: "Bank", value: (row) => row?.account?.bankName },
    { header: "Account Number", value: (row) => row?.account?.accountNumber },
    { header: "IFSC", value: (row) => row?.account?.ifsc },
    { header: "Holder", value: (row) => row?.account?.holder },
    { header: "Account Type", value: (row) => row?.account?.ac_type },
    { header: "Branch", value: (row) => row?.account?.branch },
    { header: "Status", value: (row) => statusLabel(row?.status) },
    { header: "Date", value: (row) => row?.createdAt ? moment(row.createdAt).format("lll") : "" },
  ];
  // Export: every request of the current filters, not only the visible page
  const exportFilters = () => {
    const q = Object.fromEntries(Object.entries(search).filter(([_, value]) => value !== "" && value !== 0 && value !== undefined));
    if (startDate && endDate) {
      q.startDate = startDate;
      q.endDate = endDate;
    }
    return q;
  };
  const exportRows = () =>
    collectPages(async (page, limit) => {
      const qs = new URLSearchParams({ ...exportFilters(), page, limit }).toString();
      const { data, error } = await apiCall("GET", `/get-payment-transaction?${qs}`, null, false);
      if (error) throw new Error(error?.message || "Failed to export data");
      return { rows: Array.isArray(data?.data) ? data.data : [], pages: data?.totalPages || 1 };
    }, { limit: 500 });

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      // Use tx_Id as unique key for selection
      const allRows = paymentRequests?.data || [];
      setSelectedRows(allRows.map((row) => row?.tx_Id));
      setTx_Ids(allRows.map((row) => row?.tx_Id));
      setWalletADdress(
        allRows.map((row) => row?.account?.accountNumber || "")
      );
      setAmount(allRows.map((row) => row?.withdrawal_amount));
      setUsername(allRows.map((row) => row?.username));
      setToken(allRows.map((row) => row?.token_address));
      setTokenSymbol(allRows.map((row) => row?.token_symbol));
    } else {
      setSelectedRows([]);
      setTx_Ids([]);
      setWalletADdress([]);
      setAmount([]);
      setUsername([]);
      setToken([]);
      setTokenSymbol([]);
    }
  };

  const toggleSelectRow = (index, tx_Id, address, amt, user) => {
    // Use tx_Id as unique key for selection
    if (selectedRows.includes(tx_Id)) {
      setSelectedRows(selectedRows.filter((id) => id !== tx_Id));
      setTx_Ids(tx_Ids.filter((id) => id !== tx_Id));
      setWalletADdress(walletAddress.filter((addr, i) => tx_Ids[i] !== tx_Id));
      setAmount(amount.filter((a, i) => tx_Ids[i] !== tx_Id));
      setUsername(username.filter((u, i) => tx_Ids[i] !== tx_Id));
      setToken(token.filter((t, i) => tx_Ids[i] !== tx_Id));
      setTokenSymbol(tokenSymbol.filter((s, i) => tx_Ids[i] !== tx_Id));
    } else {
      setSelectedRows([...selectedRows, tx_Id]);
      setTx_Ids([...tx_Ids, tx_Id]);
      setWalletADdress([...walletAddress, address]);
      setAmount([...amount, amt]);
      setUsername([...username, user]);
      setToken([...token, null]); // If you want to add token, pass it as param
      setTokenSymbol([...tokenSymbol, null]); // If you want to add tokenSymbol, pass it as param
    }
  };

  const handleWithDap = () => {
    navigate("/dashboard/withdraw-details", {
      state: {
        amountArray: amount,
        walletAddressArray: walletAddress,
        usernameArray: username,
        tx_IdsArray: tx_Ids,
      },
    });
  };

  const handleApproveAllClick = () => {
    setShowApproveAllModal(true);
  };

  const handleApproveAll = async () => {
    try {
      if (!tx_hash || tx_hash.trim() === "") {
        alert("Please enter transaction hash before approving all.");
        return;
      }

      console.log("tx_Ids, tx_hash", tx_Ids, tx_hash.trim());
      await dispatch(
        approveWithdrawalRequest(tx_Ids, tx_hash.trim(), "manual approval")
      );
      setShowApproveAllModal(false);
      setTxHash("");
      dispatch(
        fetchAllTransaction({
          page: 1,
          limit: 20,
          source: "withdrawal",
          status: "0",
        })
      );
    } catch (e) {
      console.log(e);
    }
  };

  const handleCancelApproveAll = () => {
    setShowApproveAllModal(false);
    setTxHash("");
  };

  const handleConfirmApprove = (tx_Id) => {
    setCurrentApproveTxId(tx_Id);
    setShowApproveModal(true);
  };

  const handleCancelApprove = () => {
    setShowApproveModal(false);
    setCurrentApproveTxId(null);
    setTxHash("");
  };

  const handleApprove = async () => {
    try {
      if (!tx_hash || tx_hash.trim() === "") {
        alert("Please enter transaction hash before approving.");
        return;
      }
      await dispatch(
        approveWithdrawalRequest(
          [currentApproveTxId],
          tx_hash.trim(),
          "manual approval"
        )
      );
      setCurrentApproveTxId(null);
      setShowApproveModal(false);
      setTxHash("");
      dispatch(
        fetchAllTransaction({
          page: 1,
          limit: 20,
          source: "withdrawal",
          status: "0",
        })
      );
    } catch (e) {
      console.log(e);
    }
  };

  const handleRejectAll = () => {
    setShowRejectionReason(true);
  };

  const handleReject = (tx_Id) => {
    setCurrentTxId(tx_Id);
  };

  const handleSaveRejectionReason = async () => {
    try {
      console.log("tx_Ids", tx_Ids);
      console.log("rejectionReason", rejectionReason);
      await dispatch(rejectWithdrawalRequest(tx_Ids, rejectionReason));
      setShowRejectionReason(false);
      dispatch(
        fetchAllTransaction({
          page: 1,
          limit: 20,
          source: "withdrawal",
          status: "0",
        })
      );
    } catch (e) {
      console.log(e);
    }
  };

  const handleSaveReason = async () => {
    try {
      await dispatch(rejectWithdrawalRequest([currentTxId], rejectionReason));
      setCurrentTxId(null);
      setRejectionReason("");
      dispatch(
        fetchAllTransaction({
          page: 1,
          limit: 20,
          source: "withdrawal",
          status: "0",
        })
      );
    } catch (e) {
      console.log(e);
    }
  };

  const getCompanyDetails = async () => {
    try {
      const res = await apiCall("GET", "/get-company-info");
      console.log("company details", res);
      setCompanyDetails(res?.data?.company_info);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleToken = (token) => {
    console.log("token details", token);
    setSelectedToken(token);
    setShow(false);
  };

  useEffect(() => {
    if (selectedToken) {
      if (value == "all") {
        handleApproveAll();
      } else if (value == "single") {
        handleApprove();
      }
    }
  }, [selectedToken]);

  var x = 0;
  useEffect(() => {
    if (x == 0) {
      getCompanyDetails();
      x++;
    }
  }, []);

  const handleApproveSelection = (value, tx_Id) => {
    setValue(value);
    setCurrentApproveTxId(tx_Id);
    setShow(true);
  };
  return (
    <React.Fragment>
      <Container>
        {show && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h2>Select Token For Withdrawal</h2>
              <div className="tokenSelection">
                {companyDetails?.tokens
                  ?.filter((token) => token.enabled === 1)
                  ?.map((token, i) => (
                    <div
                      key={i}
                      className="tokenDiv"
                      onClick={() => handleToken(token)}
                    >
                      <span>{token?.tokenName}</span>
                      {token?.token_image?.startsWith("<svg") ? (
                        <span
                          style={{ marginLeft: "5px" }}
                          dangerouslySetInnerHTML={{
                            __html: token?.token_image,
                          }}
                        />
                      ) : (
                        <img
                          src={token?.token_image}
                          alt={token?.tokenSymbol}
                          style={{ marginLeft: "5px", height: "40px" }}
                        />
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}

        <div className="pagePath">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 w-100">
            <h4 className="m-0">Pending Withdrawal</h4>
            <div>
              <ExportButtons
                title="Pending Withdrawal"
                columns={exportColumns}
                getRows={exportRows}
                filters={Object.entries(exportFilters()).filter(([k]) => k !== "source" && k !== "status").map(([k, v]) => `${k}: ${v}`).join(", ")}
              />
            </div>
          </div>
          {/* <div>
            <select
              name="token_symbol"
              value={search.token_symbol}
              onChange={handleChange}
              style={{ borderRadius: "5px", width: "100%" }}
            >
              <option value="TERA">TERA</option>
              <option value="ERA">ERA</option>
            </select>
          </div> */}
        </div>
        <Row id="filterRow">
          <span className="filterL">
            <div className="d-flex justify-content-between">
              <div onClick={() => toggleFilter()}>
                <i>
                  <BiFilter />
                </i>
                Filter
              </div>
              <div className="align-content-center">
                Total Debited Amount : {paymentRequests?.debitSum}
              </div>
            </div>
          </span>

          <Row className="p-0 m-0" style={{ display: filter }}>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  name="search"
                  placeholder="Search By Name, Username"
                  value={search.search}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  placeholder="Search User By Uid"
                  name="uid"
                  value={search.uid}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="number"
                  name="amount"
                  placeholder="Search By Amount"
                  value={search.amount}
                  onChange={handleChange}
                />
              </div>
            </Col>
            {/*<Col lg="2" md="4">
              <div>
              
              <input type="text" name='username' placeholder="Search By UserName" value={search.username} onChange={handleChange} />
               </div>
            </Col>*/}
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="startDate"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={endDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="dateFilter"
                  value={dateFilter}
                  onChange={handleDateFilterChange}
                >
                  <option value="default">Default</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name=""
                  value={limitFilter}
                  onChange={handleLimitChange}
                >
                  <option value="">--All--</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </Col>
            <div>
              <button className="save filter" onClick={Addfilter}>
                Filter{" "}
                <i>
                  <BiFilter />
                </i>
              </button>
              <button className="cancel reset" onClick={resetFilter}>
                Reset{" "}
                <i>
                  <GrPowerReset />
                </i>
              </button>
            </div>
          </Row>
        </Row>
        <div id="directIncomeDiv">
          <div className="button-container">
            {/* <button className="action-btn" onClick={handleWithDap}>
              Approve With Dap
            </button> */}
            <button
              className="action-btn"
              // onClick={() => handleApproveSelection("all")}
              onClick={handleApproveAllClick}
            >
              Approve All
            </button>
            <button className="action-btn" onClick={handleRejectAll}>
              Reject All
            </button>
          </div>
          <Modal show={showApproveAllModal} onHide={handleCancelApproveAll}>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Approve All</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <p>
                  Are you sure you want to approve all selected transactions?
                </p>
                <label style={{ display: "block", marginTop: "8px" }}>
                  Transaction Hash (tx_hash):
                </label>
                <input
                  type="text"
                  value={tx_hash}
                  onChange={(e) => setTxHash(e.target.value)}
                  placeholder="Enter transaction hash"
                  style={{ width: "100%" }}
                  required
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCancelApproveAll}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleApproveAll}>
                Approve All
              </Button>
            </Modal.Footer>
          </Modal>
          {showRejectionReason && (
            <div className="rejection-reason-container">
              <button
                className="close-btn1"
                onClick={() => setShowRejectionReason(false)}
              >
                x
              </button>
              <div className="reject-container">
                <input
                  type="text"
                  placeholder="Enter rejection reason"
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  className="rejection-reason-input"
                />
                <button
                  className="save-btn"
                  onClick={handleSaveRejectionReason}
                >
                  Save
                </button>
              </div>
            </div>
          )}
          <Row id="directTableRow" className="text-center">
            <Col md="12" className="p-0">
              <div style={{ width: "100%", display: "flex" }}>
                <table>
                  <tr>
                    <th>
                      <div className="checkbox-cell">
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={toggleSelectAll}
                          className="checkbox-input"
                          id="selectAll"
                        />
                        <label htmlFor="selectAll" className="checkbox-label">
                          <span
                            className={`custom-checkbox ${
                              selectAll ? "checked" : ""
                            }`}
                          />
                          <span className="checkbox-text">Select All</span>
                        </label>
                      </div>
                    </th>
                    <th>S. No.</th>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Uid</th>
                    {/* <th>Account Details</th> */}
                    <th>Requested Amount</th>
                    <th>Admin Fee</th>
                    <th>Transaction Charge</th>
                    <th>Withdrawal Amount</th>
                    <th>Bank Details</th>
                    {/* <th>Token Amount</th> */}
                    {/* <th>Hash Code</th> */}
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                  {paymentRequests?.data?.map((row, index) => (
                    <tr key={row?.tx_Id}>
                      {/* <td>
                <input
                  type="checkbox"
                  checked={selectedRows.includes(index)}
                  onChange={() => toggleSelectRow(index, row.tx_Id)}
                  className="checkbox-input"
                  id={`row-${index}`}
                />
                <label htmlFor={`row-${index}`} className="checkbox-label">
                  <span
                    className={`custom-checkbox ${
                      selectedRows.includes(index) ? "checked" : ""
                    }`}
                  />
                </label>
              </td> */}
                      <td>
                        <div className="checkButton">
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(row.tx_Id)}
                            onChange={() =>
                              toggleSelectRow(
                                index,
                                row.tx_Id,
                                row?.account?.accountNumber?.trim?.() || "",
                                row?.withdrawal_amount,
                                row?.username
                              )
                            }
                            className="checkbox-input"
                            id={`row-${index}`}
                          />
                          <label
                            htmlFor={`row-${index}`}
                            className="checkbox-label1"
                          >
                            <span
                              className={`custom-checkbox ${
                                selectedRows.includes(row.tx_Id)
                                  ? "checked"
                                  : ""
                              }`}
                            />
                          </label>
                          <div className="button-container1">
                            <button
                              className="action-btn1"
                              // onClick={() =>
                              //   handleApproveSelection("single", row.tx_Id)
                              // }
                              onClick={() => handleConfirmApprove(row.tx_Id)}
                            >
                              ✓
                            </button>
                            <button
                              className="action-btn1"
                              onClick={() => handleReject(row.tx_Id)}
                            >
                              ✗
                            </button>
                          </div>
                          <Modal
                            show={showApproveModal}
                            onHide={handleCancelApprove}
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Confirm Approval</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <p>
                                Are you sure you want to approve this
                                transaction?
                              </p>
                              <p>Name: {row.name}</p>
                              <p>Username: {row.username}</p>
                              <label
                                style={{ display: "block", marginTop: "8px" }}
                              >
                                Transaction Hash (tx_hash):
                              </label>
                              <input
                                type="text"
                                value={tx_hash}
                                onChange={(e) => setTxHash(e.target.value)}
                                placeholder="Enter transaction hash"
                                style={{ width: "100%" }}
                                required
                              />
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                variant="secondary"
                                onClick={handleCancelApprove}
                              >
                                Cancel
                              </Button>
                              <Button variant="primary" onClick={handleApprove}>
                                Approve
                              </Button>
                            </Modal.Footer>
                          </Modal>
                          {currentTxId === row.tx_Id && (
                            <div className="rejection-reason-container">
                              <button
                                className="close-btn1"
                                onClick={() => setCurrentTxId(null)}
                              >
                                x
                              </button>
                              <div className="reject-container">
                                <input
                                  type="text"
                                  placeholder="Enter rejection reason"
                                  value={rejectionReason}
                                  onChange={(e) =>
                                    setRejectionReason(e.target.value)
                                  }
                                  className="rejection-reason-input"
                                />
                                <button
                                  className="save-btn"
                                  onClick={handleSaveReason}
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                      <td>{index + 1 + 20 * (currentPage - 1)}</td>
                      <td>{row.name}</td>
                      <td>{row.username}</td>
                      <td>{row?.uid}</td>
                      {/* <td>
                        {" "}
                        <div className="keyValue">
                          {" "}
                          {row?.account?.accountNumber || "—"}
                          <CopyComponent
                            value={row?.account?.accountNumber || ""}
                          />
                        </div>{" "}
                      </td> */}
                      <td>{parseFloat(row.amount).toFixed(2)}</td>
                      <td>{parseFloat(row.TDS).toFixed(2)}</td>
                      <td>{parseFloat(row.tx_charge).toFixed(2)}</td>
                      <td>{parseFloat(row.withdrawal_amount).toFixed(2)}</td>
                      <td>
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            textAlign: "left",
                            fontSize: "16px",
                            lineHeight: "1.35",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ padding: "4px", whiteSpace: "nowrap" }}>
                                <strong>Bank</strong>
                              </td>
                              <td style={{ padding: "1px 0" }}>
                                {row?.account?.bankName || "—"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "4px", whiteSpace: "nowrap" }}>
                                <strong>A/C</strong>
                              </td>
                              <td style={{ padding: "1px 0" }}>
                                {row?.account?.accountNumber || "—"}
                                <CopyComponent
                                  value={row?.account?.accountNumber || ""}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "4px", whiteSpace: "nowrap" }}>
                                <strong>IFSC</strong>
                              </td>
                              <td style={{ padding: "1px 0" }}>
                                {row?.account?.ifsc || "—"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "4px", whiteSpace: "nowrap" }}>
                                <strong>Holder</strong>
                              </td>
                              <td style={{ padding: "1px 0" }}>
                                {row?.account?.holder || "—"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "4px", whiteSpace: "nowrap" }}>
                                <strong>Type</strong>
                              </td>
                              <td style={{ padding: "1px 0" }}>
                                {row?.account?.ac_type || "—"}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "4px", whiteSpace: "nowrap" }}>
                                <strong>Branch</strong>
                              </td>
                              <td style={{ padding: "1px 0" }}>
                                {row?.account?.branch || "—"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      {/* <td>
                        {parseFloat(row.transferAmountTokenWallet).toFixed(2)}
                      </td> */}
                      {/* <td>
                        {row.tx_hash === "manual approval" ? (
                          "manual approval"
                        ) : (
                          <a
                            href={`https://bscscan.com/tx/${row.tx_hash}`}
                            target="_blank"
                          >
                            {row.tx_hash}
                          </a>
                        )}
                      </td> */}
                      {row.status == 0 ? (
                        <td>Pending</td>
                      ) : row.status == 1 ? (
                        <td>Approved</td>
                      ) : (
                        <td>Rejected</td>
                      )}
                      <td>{moment(row?.createdAt).format("lll")}</td>
                    </tr>
                  ))}
                </table>
              </div>
            </Col>
          </Row>
        </div>
        <Row>
          <Col md="12">
            {
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            }
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default PendingWith;
